// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1F3OJ","inner":"Form_inner__1ZJLw","range":"Form_range__EJ2Lq","name":"Form_name__1jY0N","actions":"Form_actions__sNHfd"};